module.exports = __webpack_public_path__ + "static/media/instagram.4dd153a3.svg";